import { SaveForLaterSlideInPanelAnchorLocation } from "@redotech/redo-model/slide-in-panel/slide-in-panel-anchor-location";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const updateSaveForLaterStorefrontDisplaySettings = {
  name: "updateSaveForLaterStorefrontDisplaySettings" as const,
  input: z.object({
    teamId: z.string(),
    enabled: z.boolean(),
    title: z.string(),
    message: z.string(),
    numViewedProductsUntilPanelOpen: z.number(),
    anchorLocation: createEnum(SaveForLaterSlideInPanelAnchorLocation),
  }),
  output: z.null(),
};
